import { createBrowserRouter, RouterProvider } from "react-router-dom";

import MagicLinkHandler from "./magicLink/MagicLinkHandler";

const router = createBrowserRouter([
  {
    path: "/zippy-and-me/magic-link/:flow",
    element: <MagicLinkHandler />,
  },
]);

export default function ZippyAndMeApp() {
  return (
    <div className="overflow-hidden">
      <RouterProvider router={router} />
    </div>
  );
}
